export const canadianFeeTaxes = {
  ON: 0.13,
  NB: 0.15,
  NL: 0.15,
  NS: 0.15,
  PE: 0.15,
  BC: 0.12,
  default: 0.05,
};
